module.exports = __webpack_public_path__ + "img/hyjmd2-img1.98b1160b.png";